import React, { ReactNode } from 'react';

export interface IModalActionsProps {
    id?: string;
    children?: ReactNode | ReactNode[];
}

export function Actions(props: IModalActionsProps) {
    const { id } = props;

    return (
        <div className="modal-actions" id={`modal-actions-${id}`}>
            {props.children}
        </div>
    );
}
